// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.commons.serviceutils.exception.RemoteAbInitioErrorException
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { RemoteAbInitioErrorException } from "abweb/dto/exception/RemoteAbInitioErrorException";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class RemoteAbInitioErrorExceptionBase {
  /** Do NOT invoke directly, instead use strongly typed createRemoteAbInitioErrorExceptionBase factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cacse.RemoteAbInitioErrorException";
  }
  initFromJson(json, deserializeContext) {
    this.initRemoteAbInitioErrorException(json.exceptionTime != null ? new Date(json.exceptionTime) : null, json.message != null ? json.message : null, json.messageArgs != null ? json.messageArgs : null, json.messageCode != null ? json.messageCode : null, TSOGUtils.decodeObject(json.remoteCause, RemoteAbInitioErrorException, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "remoteCause")), json.remoteNestedErrors != null ? TSOGUtils.decodeObjectArray(json.remoteNestedErrors, RemoteAbInitioErrorException, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "remoteNestedErrors")) : null, json.remoteStackTrace != null ? json.remoteStackTrace : null);
  }
  initRemoteAbInitioErrorException(exceptionTime, message, messageArgs, messageCode, remoteCause, remoteNestedErrors, remoteStackTrace) {
    this._exceptionTime = exceptionTime;
    this._message = message;
    this._messageArgs = messageArgs;
    this._messageCode = messageCode;
    this._remoteCause = remoteCause;
    this._remoteNestedErrors = remoteNestedErrors;
    this._remoteStackTrace = remoteStackTrace;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    if (this._exceptionTime != null) {
      retVal["exceptionTime"] = this._exceptionTime;
    }
    retVal["message"] = this._message;
    if (this._messageArgs != null) {
      retVal["messageArgs"] = this._messageArgs;
    }
    if (this._messageCode != null) {
      retVal["messageCode"] = this._messageCode;
    }
    if (this._remoteCause != null) {
      retVal["remoteCause"] = TSOGUtils.toTSOGNativeObject(this._remoteCause, serializeContext);
    }
    if (this._remoteNestedErrors != null) {
      retVal["remoteNestedErrors"] = TSOGUtils.toTSOGArray(this._remoteNestedErrors, serializeContext);
    }
    if (this._remoteStackTrace != null) {
      retVal["remoteStackTrace"] = this._remoteStackTrace;
    }
    return retVal;
  }
  get exceptionTime() {
    return this._exceptionTime;
  }
  set exceptionTime(value) {
    this._exceptionTime = value;
  }
  get message() {
    return this._message;
  }
  set message(value) {
    this._message = value;
  }
  get messageArgs() {
    return this._messageArgs;
  }
  set messageArgs(value) {
    this._messageArgs = value;
  }
  get messageCode() {
    return this._messageCode;
  }
  set messageCode(value) {
    this._messageCode = value;
  }
  get remoteCause() {
    return this._remoteCause;
  }
  set remoteCause(value) {
    this._remoteCause = value;
  }
  get remoteNestedErrors() {
    return this._remoteNestedErrors;
  }
  set remoteNestedErrors(value) {
    this._remoteNestedErrors = value;
  }
  get remoteStackTrace() {
    return this._remoteStackTrace;
  }
  set remoteStackTrace(value) {
    this._remoteStackTrace = value;
  }
}
//# sourceMappingURL=RemoteAbInitioErrorExceptionBase.js.map
